import __var_0__ from '@stdlib/assert/is-positive-number';
import __var_1__ from '@stdlib/assert/is-number';
import __var_2__ from '@stdlib/assert/is-nan';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var isPositive = __var_0__.isPrimitive;
var isNumber = __var_1__.isPrimitive;
var isnan = __var_2__;


// MAIN //

/**
* Validates parameters.
*
* @private
* @param {PositiveNumber} r - number of successes until experiment is stopped
* @param {number} p - success probability
* @returns {(Error|null)} error or null
*
* @example
* var err = validate( 10, 0.5 );
* if ( err ) {
*     throw err;
* }
*/
function validate( r, p ) {
	if ( !isPositive( r ) ) {
		return new TypeError( 'invalid argument. First argument must be a positive number. Value: `' + r + '`.' );
	}
	if ( !isNumber( p ) || isnan( p ) ) {
		return new TypeError( 'invalid argument. Second argument must be a number primitive and not `NaN`. Value: `' + p + '`.' );
	}
	if ( p <= 0.0 || p >= 1.0 ) {
		return new RangeError( 'invalid argument. Second argument must be on the interval `(0,1)`. Value: `' + p + '`.' );
	}
	return null;
}


// EXPORTS //
export default validate;
